const SENSITIVE_KEY = /authorization|cookie|token|secret|password|email|phone|address|companyname|firstname|lastname|ip_address/i;

const sanitizeUrl = (value) => {
  try {
    const url = new URL(value);
    url.search = '';
    url.hash = '';
    return url.toString().replace(/\/$/, '');
  } catch {
    return String(value).split(/[?#]/)[0];
  }
};

const sanitizeValue = (value, key = '', depth = 0) => {
  if (SENSITIVE_KEY.test(key)) return '[Filtered]';
  if (depth > 5 || value === null || value === undefined) return value;
  if (Array.isArray(value)) {
    return value.map((entry) => sanitizeValue(entry, '', depth + 1));
  }
  if (typeof value !== 'object') return value;

  return Object.fromEntries(
    Object.entries(value).map(([entryKey, entryValue]) => [
      entryKey,
      sanitizeValue(entryValue, entryKey, depth + 1),
    ])
  );
};

export const sanitizeSentryEvent = (event) => {
  const sanitized = sanitizeValue(event);
  if (event.user) {
    sanitized.user = event.user.id ? { id: event.user.id } : undefined;
  }
  if (event.request?.url) {
    sanitized.request = sanitized.request || {};
    sanitized.request.url = sanitizeUrl(event.request.url);
  }
  return sanitized;
};

export const buildSentryOptions = ({
  app,
  dsn,
  environment,
  release,
  routeProvider = () => '/',
}) => ({
  dsn,
  environment,
  release,
  sendDefaultPii: false,
  beforeSend(event) {
    const sanitized = sanitizeSentryEvent(event);
    sanitized.tags = {
      ...sanitized.tags,
      app,
      environment,
      release,
      route: routeProvider(),
    };
    return sanitized;
  },
});
